import React from 'react';
import { Box, Typography, Link, Container } from '@mui/material';

const Footer = () => {
  return (
    <Box
      component="footer"
      sx={{
        py: 1,
        px: 1,
        mt: 'auto',
        backgroundColor: 'background.paper',
        borderTop: '1px solid',
        borderColor: 'divider',
      }}
    >
      <Container maxWidth="lg">
        <Box
          sx={{
            display: 'flex',
            flexDirection: { xs: 'column', sm: 'row' },
            justifyContent: 'space-between',
            alignItems: { xs: 'center', sm: 'flex-start' },
          }}
        >
          <Box sx={{ mb: { xs: 2, sm: 0 } }}>
            <Typography variant="body2" color="text.secondary" align="center">
              {'© '}
              {new Date().getFullYear()}
              {' '}
              <Link color="inherit" href="#">
                (주)흠소프트
              </Link>
              {' - 모든 권리 보유'}
            </Typography>
          </Box>
          
          <Box
            sx={{
              display: 'flex',
              flexDirection: { xs: 'column', sm: 'row' },
              alignItems: 'center',
              gap: { xs: 1, sm: 3 },
            }}
          >
            <Link href="#" color="text.secondary" underline="hover">
              <Typography variant="body2">개인정보처리방침</Typography>
            </Link>
            <Link href="#" color="text.secondary" underline="hover">
              <Typography variant="body2">이용약관</Typography>
            </Link>
            <Link href="#" color="text.secondary" underline="hover">
              <Typography variant="body2">문의하기</Typography>
            </Link>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;
